import { GetListResponse, instance } from "libs/api";

import {
  AuditAlertResponse,
  AuditAlertsRequestParams
} from "../../auditLog.types";
import { ApiRoutesAuditLog } from "../../constants";

export const requestGetAuditAlerts = async (
  params: AuditAlertsRequestParams
): Promise<GetListResponse<AuditAlertResponse>> => {
  return await instance.get(ApiRoutesAuditLog.AuditAlerts, { params });
};
